import {modals} from '../modal/init-modals';
export class Validation {
  constructor() {
    this._modals = modals;
    this._onSubmitForm = this._onSubmitForm.bind(this);
    this._emailRegex =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
    this._errors = new Set();
    this._fileInputs = new Map();
    this._maxFileSize = 10 * 1024 * 1024;
    this._namespace = 'my-app/v1';
    this._forms = document.querySelectorAll('[data-validation]');
  }

  init() {
    if (!this._forms.length || !window.smartCaptcha) {
      return;
    }
    this._forms.forEach((form) => {
      const widget = form.querySelector('[data-validation-widget]');
      if (!widget) {
        return;
      }
      const widgetId = window.smartCaptcha.render(widget, {
        sitekey: 'ysc2_o91t8y6ZluuXsDuiTg57qAI3vfewhncsyWIFoBzd110090ca',
        invisible: true,
        hideShield: true,
      });

      widget.setAttribute('data-validation-widget', widgetId);
      form.addEventListener('submit', this._onSubmitForm);
      this._initFileUpload(form);
    });
  }

  async _getToken(widgetId) {
    const response = window.smartCaptcha.getResponse(widgetId);

    if (response) {
      window.smartCaptcha.reset(widgetId);
    }

    const token = await window.smartCaptcha.executePromise(widgetId);

    return token;
  }

  _getFieldControl(field) {
    return field.querySelector('input, textarea');
  }

  _initFileUpload(form) {
    const attachmentBtns = form.querySelectorAll('[data-attachment-btn]');

    attachmentBtns.forEach((attachmentBtn) => {
      attachmentBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const attachment = attachmentBtn.closest('.form-attachment');
        const filesContainer = attachment ? attachment.querySelector('[data-attachment-files]') : null;
        const attachmentName = attachmentBtn.dataset.attachmentName;

        if (!filesContainer) {
          return;
        }

        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.multiple = true;
        fileInput.accept = '.pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.zip,.rar,.txt';
        fileInput.style.display = 'none';

        fileInput.addEventListener('change', () => {
          const files = Array.from(fileInput.files);

          if (filesContainer && files.length) {
            const oversizedFiles = files.filter(file => file.size > this._maxFileSize);

            if (oversizedFiles.length > 0) {
              const fileNames = oversizedFiles
                .map(f => `"${f.name}" (${(f.size / (1024 * 1024)).toFixed(2)} MB)`)
                .join(', ');

              alert(`Следующие файлы превышают максимальный размер 10MB:\n${fileNames}`);

              if (oversizedFiles.length === files.length) {
                fileInput.remove();
                return;
              }
            }

            const validFiles = files.filter(file => file.size <= this._maxFileSize);

            validFiles.forEach((file, index) => {
              const fileId = `file_${Date.now()}_${index}_${Math.random().toString(36).substr(2, 9)}`;

              const fileElement = document.createElement('div');
              fileElement.className = 'attachment-file';
              fileElement.dataset.attachmentFile = fileId;

              fileElement.innerHTML = `
                <svg  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.33464 2.5V5.83333C8.33464 6.05435 8.24684 6.26631 8.09056 6.42259C7.93428 6.57887 7.72232 6.66667 7.5013 6.66667H4.16797M15.8346 3.33333V16.6667C15.8346 16.8877 15.7468 17.0996 15.5906 17.2559C15.4343 17.4122 15.2223 17.5 15.0013 17.5H5.0013C4.78029 17.5 4.56833 17.4122 4.41205 17.2559C4.25577 17.0996 4.16797 16.8877 4.16797 16.6667V6.595C4.16802 6.374 4.25584 6.16208 4.41214 6.00583L7.6738 2.74417C7.83005 2.58788 8.04197 2.50005 8.26297 2.5H15.0013C15.2223 2.5 15.4343 2.5878 15.5906 2.74408C15.7468 2.90036 15.8346 3.11232 15.8346 3.33333Z" stroke="CurrentColor" stroke-width="2" stroke-linejoin="round"/>
                </svg>

                <span class="attachment-file-name">${file.name}</span>
                <button class="attachment-file-delete btn-reset" type="button" data-attachment-delete="${fileId}">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4L4 12M4 4L12 12" stroke="#CE4242" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              `;

              if (!this._fileInputs.has(form)) {
                this._fileInputs.set(form, new Map());
              }

              this._fileInputs.get(form).set(fileId, {
                file,
                fieldName: attachmentName,
                name: file.name,
                size: file.size
              });

              const deleteBtn = fileElement.querySelector('[data-attachment-delete]');
              deleteBtn.addEventListener('click', (e) => {
                e.preventDefault();

                if (this._fileInputs.has(form)) {
                  this._fileInputs.get(form).delete(fileId);
                }

                fileElement.remove();
                form.dispatchEvent(new Event('input', { bubbles: true }));
              });

              filesContainer.appendChild(fileElement);
              form.dispatchEvent(new Event('input', { bubbles: true }));
            });
          }

          fileInput.remove();
        });

        document.body.appendChild(fileInput);
        fileInput.click();
      });
    });
  }

  async _onSubmitForm(evt) {
    evt.preventDefault();

    const form = evt.target;

    const widget = form.querySelector('[data-validation-widget]');

    if (!widget) {
      return Promise.reject('Не найден контейнер капчи');
    }
    const widgetId = widget.dataset.validationWidget;
    const errors = form.querySelector('[data-validation-errors]');
    form.classList.remove('is-error');

    errors.innerHTML = '';

    this._validateForm(form);

    if (this._errors.size) {
      this._setErrors(errors);
      form.classList.add('is-error');
      return;
    }
    let token = '';
    try {
      token = await this._getToken(widgetId);
    } catch(error) {
      errors.innerHTML = this._createError(error.message || 'Не удалось пройти проверку капчи');
      return;
    }
    const formType = form.dataset.feedbackForm || 'feedback';
    const formData = new FormData(form);
    formData.append('type', formType);
    formData.append('token', token);
    if (this._fileInputs.has(form)) {
      Array.from(this._fileInputs.get(form).values()).forEach((fileData) => {
        formData.append(`${fileData.fieldName}[]`, fileData.file);
      });
    }
    this._sendFeedback(form, formData);
  }

  _validateForm(form) {
    this._errors.clear();

    const fields = form.querySelectorAll('[data-validation-type]');

    fields.forEach((field) => {
      field.classList.remove('is-error');

      const type = field.dataset.validationType;

      switch (type) {
        case 'text':
          this._validateTextField(field);
          break;
        case 'textarea':
          this._validateTextAreaField(field);
          break;
        case 'phone':
          this._validatePhoneField(field);
          break;
        case 'email':
          this._validateEmailField(field);
          break;
        case 'checkbox':
          this._validateCheckboxField(field);
          break;
      }
    });
  }

  _validateCheckboxField(field) {
    const input = this._getFieldControl(field);
    if (!input) return;

    if (!input.checked) {
      field.classList.add('is-error');
      this._errors.add('checkbox');
    }
  }

  _validateTextField(field) {
    const input = this._getFieldControl(field);
    if (!input) return;

    if (!input.value.trim()) {
      field.classList.add('is-error');
      this._errors.add('required');
    }
  }

  _validateTextAreaField(field) {
    const input = this._getFieldControl(field);
    if (!input) return;

    if (!input.value.trim()) {
      field.classList.add('is-error');
      this._errors.add('required');
    }
  }

  _validatePhoneField(field) {
    const input = this._getFieldControl(field);
    if (!input) return;

    if (!input.value.trim()) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else if (input.value.length < 18) {
      field.classList.add('is-error');
      this._errors.add('phone');
    }
  }

  _validateEmailField(field) {
    const input = this._getFieldControl(field);
    if (!input) return;

    if (!input.value.trim()) {
      field.classList.add('is-error');
      this._errors.add('required');
    } else if (!this._emailRegex.test(input.value)) {
      field.classList.add('is-error');
      this._errors.add('email');
    }
  }

  _setErrors(element) {
    let result = '';

    this._errors.forEach((error) => {
      switch (error) {
        case 'required':
          result += this._createError('Заполните все обязательные поля');
          break;
        case 'phone':
          result += this._createError('Введите корректный номер телефона');
          break;
        case 'email':
          result += this._createError('Введите корректный email');
          break;
        case 'checkbox':
          result += this._createError('Требуется согласие');
          break;
      }
    });

    element.innerHTML = result;
  }

  _createError(text) {
    return `
      <div class="errors__item">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect x="1" y="1" width="18" height="18" rx="9" stroke="CurrentColor" stroke-width="2"/>
          <path d="M11.32 7.476C11.32 8.36133 11.288 9.172 11.224 9.908C11.16 10.644 11.08 11.3853 10.984 12.132H9.608C9.50133 11.3853 9.416 10.644 9.352 9.908C9.288 9.16133 9.256 8.35067 9.256 7.476V4.5H11.32V7.476ZM11.56 14.532C11.56 14.9053 11.4373 15.2093 11.192 15.444C10.9467 15.6787 10.6427 15.796 10.28 15.796C9.928 15.796 9.624 15.6787 9.368 15.444C9.12267 15.2093 9 14.9053 9 14.532C9 14.1587 9.12267 13.8547 9.368 13.62C9.624 13.3747 9.928 13.252 10.28 13.252C10.6427 13.252 10.9467 13.3747 11.192 13.62C11.4373 13.8547 11.56 14.1587 11.56 14.532Z" fill="CurrentColor"/>
        </svg>
        <p class="errors__text">${text}</p>
      </div>
    `;
  }

  async _sendFeedback(form, formData) {
    try {
      const response = await fetch(`${wpApiSettings.root}${this._namespace}/send-feedback/`, {
        method: 'POST',
        headers: {
          'X-WP-Nonce': wpApiSettings.nonce
        },
        body: formData,
      });

      const result = await response.json();

      this._showMessage(form, result);
    } catch (err) {
      console.log('Error: ' + err);
    }
  }

  _showMessage(form, result) {
    const errors = form.querySelector('[data-validation-errors]');
    errors.innerHTML = '';

    if (result.success) {
      form.classList.add('is-success');
      if (form.closest('[data-modal]')) {
        const modal = document.querySelector('[data-modal].is-active');

        if (modal) {
          this._modals.close(modal.dataset.modal);
        }

        if (this._timeoutId) {
          clearTimeout(this._timeoutId);
        }
      }
      this._modals.open('feedback-success');
      this._timeoutId = setTimeout(() => {
        if (document.querySelector('[data-modal="feedback-success"].is-active')) {
          this._modals.close('feedback-success');
        }
      }, 3000);

      form.reset();
      const filesContainers = form.querySelectorAll('[data-attachment-files]');
      filesContainers.forEach((filesContainer) => {
        filesContainer.innerHTML = '';
      });

      if (this._fileInputs.has(form)) {
        this._fileInputs.delete(form);
      }
    } else {
      let errorResult = '';
      let errorsList = result.errors || ['Произошла ошибка, попробуйте позже'];
      errorsList.forEach((error) => {
        errorResult += this._createError(error);
      });
      errors.innerHTML = errorResult;
    }
  }

  _formDataToJson(formData) {
    const object = {};

    formData.forEach((value, key) => {
      if (!object.hasOwnProperty(key)) {
        object[key] = value;
      } else {
        if (!Array.isArray(object[key])) {
          object[key] = [object[key]];
        }
        object[key].push(value);
      }
    });

    return JSON.stringify(object);
  }
}
